<section class="order-sharing-dialog">
  <div mat-dialog-title class="dialog-header">
    @if (!isBulk) {
    <span class="title">Share {{ trademarkName }}</span>
    } @if (isBulk && bulkOrderCount === 1) {
    <span class="title">Share all results from order {{ trademarkName }}</span>
    } @if (isBulk && bulkOrderCount !== 1) {
    <span class="title"
      >Share all results from {{ bulkOrderCount }} orders</span
    >
    }
    <button
      mat-icon-button
      mat-dialog-close
      class="material-icons floatRight close-btn"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <mat-dialog-content class="dialog-content">
    <div class="member-section">
      <app-member-recipients
        [selectedRecipients]="selectedRecipients"
        (selectionChange)="onSelectionChange($event)"
      ></app-member-recipients>
    </div>
    @if (!isBulk) {
    <div class="order-section">
      <app-selected-order [paramData]="data.rowData"> </app-selected-order>
    </div>
    } @if (isBulk) {
    <div class="order-section bulk-orders">
      @for (order of bulkOrders; track order) {
      <app-selected-order [paramData]="order"></app-selected-order>
      }
    </div>
    } @if (selectedRecipients.length) {
    <div class="selected-contacts-section">
      <app-selected-recipients
        [selectedRecipients]="selectedRecipients"
        (removeRecipient)="onRemove($event)"
      >
      </app-selected-recipients>
    </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button color="primary" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      (click)="onShareOrder()"
      [disabled]="isDisabled()"
      mat-flat-button
      color="primary"
    >
      Save Sharing Settings
    </button>
  </mat-dialog-actions>
</section>
